export const positiveIntegerNumberError = 'It has to be a valid positive, non-decimal number'
export const positiveNumberError = 'It has to be a valid positive number'
export const nonNegativeNumberError = 'It has to be a valid non-negative number'
export const nonDecimalError = 'It has to be a valid non-decimal number'
export const uploadError = 'This file is too large to upload. Max file size: 6MB'
export const requiredError = 'Required input'
export const floatNumberError = (decimals: number) => `It has to be number with at most ${decimals} decimals`
